// ======================================================================
// File Name       : CourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Col, Table, Button } from 'react-bootstrap';
import ReduxFormPaging from '../../ReduxFormPaging';

class CourseList extends Component {

  render() {
    const {
      targetCourse,
      checkedCourseList,
      targetCourseList,
      checkedCourseOnModal,
      addedCourseList,
    } = this.props;
    const { courseList, recordNum } = targetCourse;


    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-bottom-15">
          <Button variant="default" onClick={this.props.handleCheckAll}>全選択/解除</Button>
        </Col>
        <Col sm={10} className="d-flex justify-content-end">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={this.props.getStartEndData}
          />
        </Col>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>コース名</th>
            </tr>
          </thead>
          <tbody>
            { targetCourse.allSecernIds.map((courseSecernId, index) => {
              const course = targetCourse.bySecernId[courseSecernId];
              const checked = checkedCourseOnModal.indexOf(courseSecernId) > -1;

              return (
                <tr key={index}>
                  <td>
                    <Form.Check
                      type='checkbox'
                      className="text-center margin-clear"
                      value={courseSecernId}
                      checked={!!addedCourseList[courseSecernId] || checked}
                      disabled={!!addedCourseList[courseSecernId]}
                      onChange={this.props.handleCheckbox} />
                  </td>
                  <td>{course.courseName}</td>
                </tr>
              );
            })}

          </tbody>
        </Table>
        <Col sm={12} className="text-center">
          <Button variant="primary" className="btn-96" onClick={this.props.handleAddCourse}>
            追加
          </Button>
        </Col>
      </Col>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { targetCourseList, addedCourseList } = state.csvDownload;
  return { targetCourseList, addedCourseList };
};
export default connect(mapStateToProps)(CourseList);
